<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Broker Notes</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-12">
        <mat-form-field appearance="outline">
          <mat-label>Please provide your submission notes here to support your application</mat-label>
          <textarea formControlName="notes" matInput
                    placeholder="Please provide your submission notes here to support your application"
                    class="form-control"></textarea>
          <mat-error>
            <ng-container *ngIf="formGroup.get('notes').hasError('required')">This field is required</ng-container>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
